<template>
  <div class="tag_container" v-if="$route.path != '/tag'">
    <div class="title">
      <i class="iconfont icon-biaoqian"></i>
      <span>标签墙</span>
      <a href="javascript:void(0)" class="more" @click="rerenderColors">点击这里抽一下金色标签</a>
    </div>
    <div class="tag">
      <span
        v-for="(item, index) in $store.state.tagCloud"
        :key="index"
        class="item"
        :style="{ backgroundColor: tagColors[index] }"
        @click="handleClick(item)"
      >
        {{ item.name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tagColors: []
    };
  },

  watch: {
    // 监听标签数据加载完后初始化颜色
    '$store.state.tagCloud': {
      handler(newVal) {
        this.rerenderColors();
      },
      immediate: true
    }
  },

  methods: {
    handleClick(item) {
      this.$router.push({ name: "/tags", query: { id: item.id, name: item.name } });
    },

    rerenderColors() {
      const colors = [];
      const tagCount = this.$store.state.tagCloud.length;

      for (let i = 0; i < tagCount; i++) {
        colors.push(this.randomColor());
      }

      this.tagColors = colors;
    },

    randomColor() {
      const rand = Math.random();
      if (rand < 0.01) {
        return '#FED700'; // 1% 概率
      }

      const otherColors = [
        '#EB4B4B',
        '#D22CE6',
        '#8846FF',
        '#4B69FF',
        '#5E98D7',
        '#B1C3D9'
      ];

      return otherColors[Math.floor(Math.random() * otherColors.length)];
    }
  }
};
</script>

<style lang="scss" scoped>
.tag_container {
    width: 300px;
    height: auto;
    margin-top: 20px;
    border-radius: 8px;
    font-size: 0.9rem;

    &:hover {
        box-shadow: 0 4px 8px 6px rgba(7, 17, 27, .06);
        transition: all .3s;
    }

    .title {
        width: 300px;
        height: 45px;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
        background-color: var(--background-color);
        border-bottom: 1px solid var(--border-line);
        font-size: 16px;
        font-weight: 700;

        i {
            color: var(--theme-color);
            padding: 0 10px 0 20px;
        }

        span {
            color: var(--box-title_color);
        }

        i,
        a,
        span {
            line-height: 45px;
        }

        .more {
            float: right;
            margin-right: 10px;
            font-size: 13px;
            color: gray;
            text-decoration: none;
        }
    }

    .tag {
        background-color: var(--background-color);
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
        padding-top: 20px;
        padding-left: 10px;
        padding-bottom: 10px;
        height: auto;

        span {
            text-decoration: none;
            margin-left: 10px;
            padding: 5px;
            display: inline-block;
            margin-bottom: 10px;
            border-radius: 8px;
            color: #fff;
            cursor: pointer;
            transition: all .3s;

            &:hover {
                border-radius: 0;
            }
        }
    }

}
</style>